import React from 'react';
import { useSelector } from 'react-redux';
import { getOnlineBookingPreferences } from 'reducers/marketplace/MarketplaceSelectors';
import { getServices } from 'reducers/services/ServicesSelectors';

export const useIsOnlineBookingEnabled = () => {
    const services = useSelector(getServices);
    const { enabled } = useSelector(getOnlineBookingPreferences);

    return React.useMemo(() => {
        return enabled && services.length > 0;
    }, [enabled, services]);
};
